import { Icon, IconButton, Tooltip } from "@tm/components"
import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { BasketPart } from "../../../../../../../models"
import { EditDialog } from "./EditDialog"
import { CustomOrderPriceCalculation } from "../../../../../../../data/model"

type Props = {
    disabled?: boolean
    hidePurchasePrice?: boolean
    part: BasketPart
    onEditOrderPrice?(part: BasketPart, customOrderPriceCalculation: CustomOrderPriceCalculation): void
}

export function EditButton(props: Props) {
    const { part, disabled, hidePurchasePrice, onEditOrderPrice } = props
    const { translateText } = useLocalization()

    const [showEditDialog, setShowEditDialog] = useState<boolean>(false)

    return (
        <>
            <Tooltip title={translateText(122)}>
                <IconButton onClick={() => setShowEditDialog(true)} disabled={disabled}>
                    <Icon name="edit_change" />
                </IconButton>
            </Tooltip>
            {showEditDialog && (
                <EditDialog
                    part={part}
                    disableHeaderButtons={disabled}
                    hidePurchasePrice={hidePurchasePrice}
                    onEditOrderPrice={onEditOrderPrice}
                    onCloseButtonClick={() => setShowEditDialog(false)}
                />
            )}
        </>
    )
}
